import React, { Component } from 'react';

import styles from './HeroSplitPanes.scss';
import LinkOverride from 'Containers/LinkOverride';
import Button from 'Components/Button';

class HeroSplitPanes extends Component {
  constructor(props) {
    super(props);
    this.onAdClick = this.onAdClick.bind(this);
  }

  componentDidMount() {
    if (this.props.sponsored) this.props.onAdLoad();
  }

  onAdClick(e) {
    const el = e.target.dataset.clickelementid
      ? e.target
      : e.target.parentElement;
    this.props.onAdClick(el.dataset.clickelementid);
  }

  render() {
    const {
      imageURI,
      title,
      dek,
      mediaType,
      link,
      externalLink,
      buttonLabel,
      sponsored,
      logoImageURI,
      sponsoredBugText,
      impressionTrackingPixel,
      id,
      buttons,
    } = this.props;

    const clickHandler = sponsored ? this.onAdClick : undefined;
    const buttonDefaults = {
      clickHandler,
      clickElementId: 'HeroButton',
      buttonSize: 'hero',
      withAction: true,
    };
    const buttonProps = link
      ? {
          ...buttonDefaults,
          to: link,
          text: buttonLabel,
          mediaType,
        }
      : {
          ...buttonDefaults,
          externalLink,
          text: buttonLabel,
        };

    const getSponsoredBug = () => {
      if (!sponsored) return null;
      const text = sponsoredBugText || 'Sponsored';
      if (logoImageURI) {
        return (
          <div className="HeroSplitPanes__sponsored with-logo">
            {text}{' '}
            <img
              src={logoImageURI}
              className="HeroSplitPanes__sponsored-logo"
              alt={title}
            />
          </div>
        );
      }
      return <div className="HeroSplitPanes__sponsored">{text}</div>;
    };

    return (
      <div className={`HeroSplitPanes${id ? ` HeroSplitPanes--${id}` : ''}`}>
        <LinkOverride
          onClick={clickHandler}
          link={link}
          externalLink={externalLink}
          className="HeroSplitPanes__media"
          data-type={mediaType}
        >
          <img
            alt="hero"
            data-clickelementid="HeroImage"
            className="HeroSplitPanes__image"
            src={imageURI}
          />
        </LinkOverride>
        <div className="HeroSplitPanes__text">
          {getSponsoredBug()}
          <h2 className="HeroSplitPanes__headline">{title}</h2>
          <p className="HeroSplitPanes__description">{dek}</p>
          {buttons ? (
            <div>
              {buttons.map(props => (
                <div key={props.text} className="HeroSplitPanes__buttonWrapper">
                  <Button {...props} />
                </div>
              ))}
            </div>
          ) : (
            <Button {...buttonProps} />
          )}
        </div>
        {impressionTrackingPixel && (
          <div
            className="HeroSplitPanes__tracking-pixel"
            dangerouslySetInnerHTML={{ __html: impressionTrackingPixel }}
          />
        )}
      </div>
    );
  }
}

export default HeroSplitPanes;
